module.exports = __webpack_public_path__ + "static/media/t2.849b8ede.png";